var _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.6 32.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Cancel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "replaceAccent1CON",
    d: "m17.4 15.7v2.1l0.7 0.2s0-0.6 0.2-1 0.4-0.7 0.3-1-1.2-0.3-1.2-0.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "replaceAccent1CON",
    d: "m15 14.6-0.1 7.6 3.7 1.8s-0.8-1-0.4-5.7l-0.8-0.4v-2.6l-2.4-0.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "replaceAccent1CON",
    points: "21.1 11.5 15.3 14.3 17.5 15.3 20 14 20.9 14.3 22.8 12.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m27.4 13.9-6.2-2.7h-0.3l-6.2 2.7c-0.1 0.1-0.2 0.2-0.2 0.4v7.7c0 0.1 0.1 0.3 0.2 0.4l6.2 3.2h0.4l6.2-3.1c0.1-0.1 0.2-0.2 0.2-0.4v-7.8c-0.1-0.2-0.2-0.4-0.3-0.4zm-6.3-1.9 5.2 2.3-5.2 2.3-1.3-0.6 2.1-0.9 0.1-0.1c0.1-0.1 0.1-0.4 0-0.5 0 0-0.1-0.1-0.2-0.1-0.3-0.1-1.1-0.5-1.4-0.6-0.1 0-0.3-0.1-0.5 0-0.1 0.1-2.6 1.2-2.6 1.2l-1.2-0.6 5-2.4zm-3.5 4 0.9 0.3v1.6l-0.9-0.4v-1.5zm0.4-0.7 1.9-0.8 0.7 0.3-1.9 0.8-0.7-0.3zm-2.7-0.3 1.6 0.7v2.2c0 0.2 0.1 0.3 0.2 0.4l1.6 0.8c0.1 0 0.3 0 0.4-0.1s0.2-0.2 0.2-0.3v-2l1.6 0.7v7.4l-5.7-2.8 0.1-7zm6.1 9.8v-7.4l5.6-2.4v7l-5.6 2.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m12.9 1.7c-0.1 0-0.2 0.1-0.2 0.2v0.5c0 0.1 0.1 0.2 0.2 0.2s0.2-0.1 0.2-0.2v-0.5c0-0.1-0.1-0.2-0.2-0.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m12.3 1.2h-0.5c-0.1 0-0.2 0.1-0.2 0.2s0.1 0.2 0.2 0.2h0.5c0.1 0 0.2-0.1 0.2-0.2s-0.1-0.2-0.2-0.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m12.9 0.3c-0.1 0-0.2 0.1-0.2 0.2v0.5c0 0.1 0.1 0.2 0.2 0.2s0.2-0.1 0.2-0.2v-0.5c0-0.1-0.1-0.2-0.2-0.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m13.9 1.2h-0.5c-0.1 0-0.2 0.1-0.2 0.2s0.1 0.2 0.2 0.2h0.5c0.1 0 0.2 0 0.3-0.2-0.1-0.1-0.1-0.2-0.3-0.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m35.6 26c-0.2 0-0.3 0.2-0.3 0.3v0.8c0 0.2 0.1 0.3 0.3 0.4 0.2 0 0.3-0.2 0.3-0.4v-0.8c0-0.1-0.1-0.3-0.3-0.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m34.7 25.2h-0.8c-0.2 0-0.3 0.1-0.3 0.3s0.2 0.3 0.3 0.3h0.8c0.2 0 0.3-0.1 0.3-0.3s-0.1-0.3-0.3-0.3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m35.6 23.5c-0.2 0-0.3 0.2-0.3 0.3v0.8c0 0.2 0.1 0.3 0.3 0.4 0.2 0 0.3-0.2 0.3-0.4v-0.8c0-0.2-0.1-0.3-0.3-0.3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m37.2 25.2h-0.8c-0.2 0-0.3 0.1-0.3 0.3s0.2 0.3 0.3 0.3h0.8c0.2 0 0.3-0.1 0.3-0.3 0.1-0.2-0.1-0.3-0.3-0.3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m2 21.8s0.3 2-2 1.9c0 0 2 0 1.9 1.9 0.2-1 1-1.7 2-1.8 0 0-1.5 0.3-1.9-2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "replaceAccent2CON",
    d: "m33.7 7.7s0.3 2-2 1.9c0 0 2 0 1.9 1.9 0.2-1 1-1.7 2-1.8 0 0-1.5 0.4-1.9-2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "replaceAccent2CON",
    d: "m11.7 29.6c0 0.6-0.4 1-0.9 1.1h-0.2c0.6 0 1 0.4 1 1 0.1-0.5 0.5-0.9 1.1-1 0 0-0.9 0.2-1-1.1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m5.8 12.6s0.1 0.7-0.7 0.7c0 0 0.7 0 0.7 0.7 0.1-0.3 0.4-0.6 0.7-0.6-0.1-0.1-0.6 0-0.7-0.8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m39.8 16.4s0.1 0.7-0.7 0.7c0 0 0.7 0 0.7 0.6 0.1-0.3 0.4-0.6 0.7-0.6 0 0-0.6 0.2-0.7-0.7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m8.3 15.3c-0.1 0.4-0.1 0.9-0.1 1.3 0 0.2 0.2 0.4 0.5 0.4 0.2 0 0.5-0.2 0.5-0.4 0-0.4 0-0.8 0.1-1.2 0-0.2-0.2-0.4-0.4-0.4-0.3 0-0.5 0.1-0.6 0.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "replaceIllPrimaryCON",
    d: "m20.6 5.4c-2.7 0-5.3 0.9-7.4 2.5l0.6-1.5c0.1-0.2 0-0.5-0.2-0.6s-0.4 0-0.5 0.2l-1.1 2.7v0.4c0 0.2 0.2 0.4 0.5 0.4h2.8c0.2 0 0.4-0.2 0.4-0.4v-0.1c0-0.2-0.2-0.4-0.5-0.4h-1.5c5-3.8 12.1-2.8 15.9 2.2s2.8 12.1-2.2 15.9c-2 1.5-4.4 2.3-6.9 2.3-6 0-11-4.7-11.4-10.7v-0.1c0-0.3-0.2-0.5-0.5-0.5-0.2 0-0.4 0.2-0.4 0.5v0.1c0.2 3 1.4 5.9 3.6 8 2.3 2.3 5.4 3.6 8.7 3.6 6.8 0 12.3-5.5 12.3-12.3s-5.4-12.2-12.2-12.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "replaceAccent1CON",
    d: "m18 15.3 0.7 0.3 1.8-0.8-0.6-0.3-1.9 0.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "replaceAccent1CON",
    d: "m23.8 20.9-1.4 0.8c-0.2 0.1-0.5 0-0.6-0.2s0-0.5 0.2-0.6l1.4-0.8c0.2-0.1 0.5 0 0.6 0.2s0 0.5-0.2 0.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "replaceAccent1CON",
    d: "m23.8 22.6-1.4 0.8c-0.2 0.1-0.5 0-0.6-0.2s0-0.5 0.2-0.6l1.4-0.8c0.2-0.1 0.5 0 0.6 0.2s0 0.5-0.2 0.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "replaceAccent2CON",
    d: "m0.5 5c-0.2 0-0.5 0.2-0.5 0.5s0.3 0.5 0.5 0.5 0.5-0.2 0.5-0.5-0.2-0.5-0.5-0.5zm0 0.8c-0.2 0-0.3-0.1-0.3-0.3s0.1-0.3 0.3-0.3 0.3 0.1 0.3 0.3-0.1 0.3-0.3 0.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimComplete);
export default __webpack_public_path__ + "static/media/claim-complete.d3f06c2146853a929181bec35b766460.svg";
export { ForwardRef as ReactComponent };